"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var country_1 = tslib_1.__importDefault(require("./country"));
var CountryTaxCodeResource = /** @class */ (function (_super) {
    tslib_1.__extends(CountryTaxCodeResource, _super);
    function CountryTaxCodeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountryTaxCodeResource.endpoint = '/countrytaxcodes';
    CountryTaxCodeResource.MODEL_NAME = 'countrytaxcode';
    CountryTaxCodeResource.related = {
        country: country_1.default,
    };
    return CountryTaxCodeResource;
}(base_1.default));
exports.default = CountryTaxCodeResource;
//# sourceMappingURL=countrytaxcode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/countrytaxcode.js
// module id = KSNE
// module chunks = 0